import { instance } from './index';
import { useQuery, useMutation, useQueryClient } from 'react-query';

const contextPath = '/common';
const CODE_LIST_CONST = {
    status : {
        query_nm : 'STATIS_CODE_LIST',
        tbl_nm : 'items',
        col_nm : 'status',
    },
    pur_tp: {
        query_nm : 'PUR_TP_CODE_LIST',
        tbl_nm : 'items',
        col_nm : 'pur_tp',
    },
    isp_tp: {
        query_nm : 'ISP_TP_CODE_LIST',
        tbl_nm : 'inspects',
        col_nm : 'isp_tp',
    },
    isp_kd: {
        query_nm : 'ISP_KD_CODE_LIST',
        tbl_nm : 'inspects',
        col_nm : 'isp_kd',
    },
    isp_st: {
        query_nm : 'ISP_ST_CODE_LIST',
        tbl_nm : 'inspects',
        col_nm : 'isp_st',
    },
    isp_ret_st: {
        query_nm : 'RET_ST_CODE_LIST',
        tbl_nm : 'inspects_hist',
        col_nm : 'ret_st',
    },
    iot_tp: {
        query_nm : 'IOT_TP_CODE_LIST',
        tbl_nm : 'inouts',
        col_nm : 'iot_tp',
    },
    io_st: {
        query_nm : 'IO_ST_CODE_LIST',
        tbl_nm : 'inouts_hist',
        col_nm : 'io_st',
    },
    io_ret_st: {
        query_nm : 'IO_RET_ST_CODE_LIST',
        tbl_nm : 'inouts_hist',
        col_nm : 'ret_st',
    },
    user_dept: {
        query_nm : 'USER_DEPT_CODE_LIST',
        tbl_nm : 'users',
        col_nm : 'dept_cd',
    },
    user_tp: {
        query_nm : 'USER_TP_CODE_LIST',
        tbl_nm : 'users',
        col_nm : 'user_tp',
    },
    sub_tp: {
        query_nm : 'SUB_TP_CODE_LIST',
        tbl_nm : 'inouts',
        col_nm : 'sub_tp',
    },
    sup_cd: {
        query_nm : 'SUPP_CD_CODE_LIST',
        tbl_nm : 'supplies',
        col_nm : 'sup_cd',
    },
    sup_st: {
        query_nm : 'SUPP_ST_CODE_LIST',
        tbl_nm : 'supplies',
        col_nm : 'sup_st',
    },
} 

export const useGetCodeList = (param) => {
    const sendParam = CODE_LIST_CONST[param];
    return useQuery(sendParam.query_nm, () => getCodeList(sendParam));
}


export const useGetStatusList = (param) => {
    const sendParam = {
        tbl_nm : 'items',
        col_nm : 'status',
    }
    return useQuery('STATUS_CODE_LIST', () => getCodeList(sendParam));
}

const getCodeList = async (param) => {
    const retVal = await instance.get(contextPath+'/codeList', {params:param})
                                    .then((res)=>{
                                        return res.data;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

export const useGetCategoryList = () => {
    return useQuery('CATEGORY_LIST', () => getCategoryList());
}

const getCategoryList = async () => {
    const retVal = await instance.get(contextPath+'/categoryList')
                                    .then((res)=>{
                                        return res.data;
                                    })
    return retVal;
}

export const useGetMafList = () => {
    return useQuery('MANUFACTS_LIST', () => getManufactsList());
}

const getManufactsList = async () => {
    const retVal = await instance.get(contextPath+'/manufactsList')
                                    .then((res)=>{
                                        return res.data;
                                    })
    return retVal;
}

export const useGetUserList = (param) => {
    const sendParam = {
        is_use : param && param.is_use > -1 ? param.is_use : undefined,
    }
    return useQuery('USER_LIST', () => getUserList(sendParam));
}

const getUserList = async (param) => {
    const retVal = await instance.get(contextPath+'/userList', {params:param})
                                    .then((res)=>{
                                        return res.data[0];
                                    })
    return retVal;
}

export const useGetClientList = (param) => {
    const sendParam = {
        is_use : 1,
        is_gov : param && param.is_gov > -1 ? param.is_gov : undefined,
    }
    return useQuery('CLIENT_LIST', () => getClientList(sendParam));
}

const getClientList = async (param) => {
    const retVal = await instance.get(contextPath+'/clientList', {params:param})
                                    .then((res)=>{
                                        return res.data[0];
                                    })
    return retVal;
}


export const useSetClient = () => {
    const queryClient = useQueryClient();
    return useMutation(
        (sendParam) => {
            switch(sendParam.mode){
                case 'POST':
                    return postClient(sendParam);
                case 'PUT':
                    return putClient(sendParam);
                case 'DELETE':
                    return deleteClient(sendParam);
                default :
                    return putClient(sendParam);
            }
        },
        {
            onSuccess:()=>{
                queryClient.invalidateQueries('CLIENT_LIST', { refetchInactive: true })
            },
        }
    )
}

const postClient = async (param) => {

    const sendParam = {
        cnm: param.cnm,
        biz_no: param.biz_no,
        phn_no: param.phn_no,
        owner: param.owner,
        addr: param.addr,
        descr: param.descr,
        is_gov: param.is_gov,
        is_use: param.is_use,
    }

    const retVal = await instance.post(contextPath+'/client', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

const putClient = async (param) => {

    const sendParam = {
        cid: param.cid,
        cnm: param.cnm,
        biz_no: param.biz_no,
        phn_no: param.phn_no,
        owner: param.owner,
        addr: param.addr,
        descr: param.descr,
        is_gov: param.is_gov,
        is_use: param.is_use,
    }

    const retVal = await instance.put(contextPath+'/client', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}

const deleteClient = async (param) => {

    const sendParam = {
        cid: param.cid,
    }

    const retVal = await instance.put(contextPath+'/delClient', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
                                    // .catch((err)=>{
                                    //     return err;
                                    // })
    return retVal;
}